"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameOrigin = void 0;
/**
 * Determines whether two valid URLs are of the same origin.
 *
 * There is no URL normalization, thus
 * `isSameOrigin('http://localhost', 'localhost')` is `false`.
 */
function isSameOrigin(urlA, urlB) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = urlA;
    var protocolA = a.protocol, hostA = a.host;
    a.href = urlB;
    var protocolB = a.protocol, hostB = a.host;
    // Internet Explorer doesn't implement HTMLAnchorElement.origin,
    // so we consider origin to be the same when their protocols,
    // hostnames, and ports match exactly. Note that HTMLAnchorElement
    // normalizes the URL (lowercases it, removes trailing slash) and
    // HTMLAnchorElement.host value already includes the port, for ex:
    // "HTTP://Example.com:8080/foo"
    //   - protocol: "http:"
    //   - host: "example.com:8080"
    return protocolA === protocolB && hostA === hostB;
}
exports.isSameOrigin = isSameOrigin;
